// extracted by mini-css-extract-plugin
export default {"avatar":"IssuesFilter_avatar__QlALL","active":"IssuesFilter_active__uBfjT"};